export default __webpack_public_path__ + "static/media/echope-home.3901e277.png";